// import { webServiceCall } from "../../services/pantherService";
// await webServiceCall("MethodName", { param1: value1, param2: value2 });

const SOAP_URL = process.env.REACT_APP_API_URL + "/Panther.asmx";

const escapeXml = (unsafe) =>
  String(unsafe ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");

export async function webServiceCall(method, params = {}, resultTag) {
  try {
    const paramXml = Object.entries(params)
      .map(([key, value]) => `<${key}>${escapeXml(value)}</${key}>`)
      .join("\n");

    const soapBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
                     xmlns:xsd="http://www.w3.org/2001/XMLSchema"
                     xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <${method} xmlns="https://lynx.catss.org.uk/Panther">
            ${paramXml}
          </${method}>
        </soap:Body>
      </soap:Envelope>`;

    const response = await fetch(SOAP_URL, {
      method: "POST",
      headers: {
        "Content-Type": "text/xml; charset=utf-8",
        SOAPAction: `https://lynx.catss.org.uk/Panther/${method}`,
      },
      body: soapBody,
    });

    const text = await response.text();
    const xml = new DOMParser().parseFromString(text, "text/xml");

    const fault = xml.getElementsByTagName("faultstring")[0];
    if (fault) {
      throw new Error(fault.textContent || `SOAP fault in ${method}`);
    }

    const resultNode = xml.getElementsByTagName(
      resultTag || `${method}Result`
    )[0];

    if (!resultNode) return null;

    const resultText = resultNode.textContent;

    try {
      return JSON.parse(resultText);
    } catch {
      return resultText;
    }
  } catch (err) {
    console.error(`SOAP call to ${method} failed`, err);
    throw err;
  }
}